var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDjango(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4344 0H19.3394V22.7075C16.8231 23.185 14.9756 23.3763 12.9694 23.3763C6.98063 23.3763 3.85938 20.6687 3.85938 15.4762C3.85938 10.4737 7.17188 7.22625 12.3006 7.22625C13.0969 7.22625 13.7019 7.28875 14.4344 7.48V0ZM14.4344 11.4287C13.9012 11.2486 13.3408 11.1624 12.7781 11.1737C10.2931 11.1737 8.86062 12.7025 8.86062 15.38C8.86062 17.9925 10.2306 19.425 12.7469 19.425C13.2881 19.425 13.7344 19.3937 14.4344 19.2975V11.4287ZM27.1444 7.575V18.9475C27.1444 22.865 26.8581 24.745 25.9981 26.3687C25.2019 27.93 24.1506 28.9175 21.9844 30L17.4294 27.8337C19.5956 26.815 20.6469 25.9212 21.3156 24.5525C22.0169 23.1513 22.2394 21.5263 22.2394 17.2588V7.57375L27.1444 7.575ZM22.2394 0.02625H27.1444V5.05875H22.2394V0.02625Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDjango);
export default __webpack_public_path__ + "static/media/django.6701aba94a46bb6dbda246f6a788c92e.svg";
export { ForwardRef as ReactComponent };